import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { UpdateAssociatedPaymentMethodRequestPayload } from '@/models/ps-management/multi-methods.model';

export default class UpdateAssociatedPaymentMethodRequest extends ApiResourceMethod<{}> {
  public perform(payload: UpdateAssociatedPaymentMethodRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${payload.multiMethodId}/billingPaymentMethod`,
        data: payload.associatedBillingMethodData,
      },
      (response: BaseResponse<{}>) => {
        return response.data;
      },
    );
  }
}
